import React, { useCallback, FunctionComponent } from 'react';
import { Presentation } from './presentation';
import type { NavigationLink } from './types';

type Props = {
  navigationLinks: NavigationLink[];
  isFirst?: boolean;
  isLast?: boolean;
};

export const Component: FunctionComponent<Props> = ({ navigationLinks, isFirst, isLast }) => {
  const handleOpenMenu = useCallback((event: React.MouseEvent<HTMLHeadingElement>) => {
    const content = $(event.currentTarget).next();
    content.slideToggle();
    $(event.currentTarget).toggleClass('active');
  }, []);

  return <Presentation navigationLinks={navigationLinks} isFirst={isFirst} isLast={isLast} handleOpenMenu={handleOpenMenu} />;
};
